// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"uMZ79","small":"FXr06","ffButton":"bvTXV","chatButton":"w-xZV","medium":"UY8w-","large":"Rv2gR","fullWidth":"rwEuz"};